import React from 'react'
import './Preload.scss'



export const Preload = () => {
  return (
    <div className="preload-main-div">
      <div className="main-text">
        <div className="top-portion">
          There is no charm equal to
          <div className="color-baby-pink">tenderness of heart</div>
        </div>
        <div className="bottom-portion">
            - Jane Austen
        </div>
      </div>
    </div>
  )
}
